import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '../../service/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { CompoundFilter, PredicateFilter, TaskTemplate, isCompoundFilter } from 'na-lib';
import { WorkTaskTemplateEditValueDialogComponent } from '../../worktask/work-task-template-edit-value-dialog/work-task-template-edit-value-dialog.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-work-task-template-advanced-dialog',
    templateUrl: './work-task-template-advanced-dialog.component.html',
    styleUrls: ['./work-task-template-advanced-dialog.component.css'],
    standalone: false
})
export class WorkTaskTemplateAdvancedDialogComponent implements OnInit, OnDestroy {
  workTaskTemplateForm!:FormGroup
  workTaskTemplateData: TaskTemplate
  tasktemplateUserRights_update:any
  contentTypesList:any=[]
  titleKeys:any=[]
  predicates:any=[]
  private contextChangeSubscription: Subscription

  constructor(
    public dialogRef: MatDialogRef<WorkTaskTemplateAdvancedDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any[],
    public dialog: MatDialog,
    private settingsService : SettingsService,
    private translate:TranslateService
  ){
    dialogRef.disableClose = true;
  }

  ngOnInit():void{
    this.tasktemplateUserRights_update = this.settingsService.modulesRolesRights$.value['workTaskTemplates']['U']
    this.settingsService.modulesRolesRights$.subscribe( value => {
      this.tasktemplateUserRights_update = this.settingsService.modulesRolesRights$.value['workTaskTemplates']['U']
    })

    this.loadContentTypes();

    this.contextChangeSubscription = this.settingsService.contextIdChange$.subscribe(() => {
      this.loadContentTypes();
    });
    this.workTaskTemplateData = new TaskTemplate()
    this.workTaskTemplateData.setFromAny(this.data.values)

    this.workTaskTemplateForm = this.fb.group({
      tridySource:[],
      contentType:[],
      visibleInPass:[],
      actions:[],
      titleKeys:[],
      predicates:[],
      createContent:[],
      incomingTridys:[],
      outgoingTridys:[],
      taskType:[],
      showImages:[],
      showComment:[],
      hidden:[],
      gpsMandatory:[],
    })

    const {tridySource, contentType, visibleInPass, actions, titleKeys, predicates,incomingTridys,outgoingTridys,taskType,groupId,showImages,showComment, hidden, gpsMandatory} = this.workTaskTemplateData

    this.workTaskTemplateForm.patchValue({
      tridySource:tridySource ? tridySource : undefined,
      contentType: contentType ? contentType : undefined,
      visibleInPass:visibleInPass ? visibleInPass : false,
      actions:actions ? actions : undefined,
      titleKeys: titleKeys ? titleKeys : undefined,
      predicates: predicates ? predicates : undefined,
      createContent:undefined,
      incomingTridys : incomingTridys ? incomingTridys : undefined,
      outgoingTridys: outgoingTridys ? outgoingTridys :undefined,
      taskType: taskType ? taskType : undefined,
      groupId: groupId ? groupId : undefined,
      showImages:showImages,
      showComment:showComment,
      hidden: hidden ? hidden : undefined,
      gpsMandatory: gpsMandatory ? gpsMandatory : undefined
    })

      this.titleKeys = titleKeys 
      if(!titleKeys){
        this.titleKeys = []
      }
      this.predicates = predicates ? predicates : []
      this.workTaskTemplateForm.patchValue({predicates: this.predicates})
  }

  deleteTitleKey(titleKey, index){
    if(this.tasktemplateUserRights_update){
      this.titleKeys.splice(index,1)
      this.workTaskTemplateForm.patchValue({titleKeys:this.titleKeys})
    }
  }

  addTitleKey(){
    const value = "new"
    this.titleKeys.push(value)
    this.workTaskTemplateForm.patchValue({titleKeys:this.titleKeys})
  }

  updateTitleKey(s, index){
    if(this.tasktemplateUserRights_update){
      let dialogRef = this.dialog.open(WorkTaskTemplateEditValueDialogComponent, {
        data: { 
          value: s,
          type:'Title Key'
        },
        width: '600px'
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result[1]){
          this.titleKeys[index] = result[0].value

        }
      });
    }
  }

  onPredicatesChange(predicates: any[]) {
    this.predicates = predicates
    this.workTaskTemplateForm.patchValue({predicates: this.predicates})
  }

  private removeEmptyPredicateGroups(predicates: PredicateFilter[]): PredicateFilter[] {
    return predicates.reduce((cleaned: PredicateFilter[], predicate: PredicateFilter) => {
      if (isCompoundFilter(predicate)) {
        const key = (predicate as CompoundFilter).and ? 'and' : 'or'
        const children = this.removeEmptyPredicateGroups(((predicate as CompoundFilter)[key] || []) as PredicateFilter[])

        if (children.length > 0) {
          cleaned.push({ [key]: children } as CompoundFilter)
        }

        return cleaned
      }

      cleaned.push(predicate)
      return cleaned
    }, [])
  }

  onDone(){
    const newValues = this.workTaskTemplateForm.value
    newValues.predicates = this.removeEmptyPredicateGroups(newValues.predicates || [])
    
    this.dialogRef.close([newValues, true])
  }

  onCancel(){
    this.dialogRef.close([this.data, false])
  }

  loadContentTypes(): void {
    this.settingsService.observeContextsContentTypesFirestoreWithId(this.settingsService.contextId$).subscribe(contentTypes => {
      this.contentTypesList = contentTypes;
    });
  }

  ngOnDestroy(): void {
    if (this.contextChangeSubscription) {
      this.contextChangeSubscription.unsubscribe();
    }
  }
}
